/* tslint:disable */
/* eslint-disable */
/**
 * Micro Interactions B Service
 * API for micro-interactions
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
  ApiPetAttributeEligibilityAgeRangeMonths,
  ApiPetAttributeEligibilityAgeRangeMonthsFromJSON,
  ApiPetAttributeEligibilityAgeRangeMonthsFromJSONTyped,
  ApiPetAttributeEligibilityAgeRangeMonthsToJSON,
} from './ApiPetAttributeEligibilityAgeRangeMonths';
import {
  ApiPetAttributeEligibilityAllergies,
  ApiPetAttributeEligibilityAllergiesFromJSON,
  ApiPetAttributeEligibilityAllergiesFromJSONTyped,
  ApiPetAttributeEligibilityAllergiesToJSON,
} from './ApiPetAttributeEligibilityAllergies';
import {
  ApiPetAttributeEligibilityBirthday,
  ApiPetAttributeEligibilityBirthdayFromJSON,
  ApiPetAttributeEligibilityBirthdayFromJSONTyped,
  ApiPetAttributeEligibilityBirthdayToJSON,
} from './ApiPetAttributeEligibilityBirthday';
import {
  ApiPetAttributeEligibilityMedicalConditions,
  ApiPetAttributeEligibilityMedicalConditionsFromJSON,
  ApiPetAttributeEligibilityMedicalConditionsFromJSONTyped,
  ApiPetAttributeEligibilityMedicalConditionsToJSON,
} from './ApiPetAttributeEligibilityMedicalConditions';
import {
  ApiPetAttributeEligibilityMedicationAllergies,
  ApiPetAttributeEligibilityMedicationAllergiesFromJSON,
  ApiPetAttributeEligibilityMedicationAllergiesFromJSONTyped,
  ApiPetAttributeEligibilityMedicationAllergiesToJSON,
} from './ApiPetAttributeEligibilityMedicationAllergies';
import {
  ApiPetAttributeEligibilityMedications,
  ApiPetAttributeEligibilityMedicationsFromJSON,
  ApiPetAttributeEligibilityMedicationsFromJSONTyped,
  ApiPetAttributeEligibilityMedicationsToJSON,
} from './ApiPetAttributeEligibilityMedications';
import {
  ApiPetAttributeEligibilityWeight,
  ApiPetAttributeEligibilityWeightFromJSON,
  ApiPetAttributeEligibilityWeightFromJSONTyped,
  ApiPetAttributeEligibilityWeightToJSON,
} from './ApiPetAttributeEligibilityWeight';

/**
 *
 * @export
 * @interface ApiPetAttributeEligibility
 */
export interface ApiPetAttributeEligibility {
  /**
   *
   * @type {boolean}
   * @memberof ApiPetAttributeEligibility
   */
  profilePhoto?: boolean;
  /**
   *
   * @type {ApiPetAttributeEligibilityWeight}
   * @memberof ApiPetAttributeEligibility
   */
  weight?: ApiPetAttributeEligibilityWeight;
  /**
   *
   * @type {ApiPetAttributeEligibilityMedicalConditions}
   * @memberof ApiPetAttributeEligibility
   */
  medicalConditions?: ApiPetAttributeEligibilityMedicalConditions;
  /**
   *
   * @type {ApiPetAttributeEligibilityAllergies}
   * @memberof ApiPetAttributeEligibility
   */
  allergies?: ApiPetAttributeEligibilityAllergies;
  /**
   *
   * @type {ApiPetAttributeEligibilityMedications}
   * @memberof ApiPetAttributeEligibility
   */
  medications?: ApiPetAttributeEligibilityMedications;
  /**
   *
   * @type {ApiPetAttributeEligibilityMedicationAllergies}
   * @memberof ApiPetAttributeEligibility
   */
  medicationAllergies?: ApiPetAttributeEligibilityMedicationAllergies;
  /**
   *
   * @type {ApiPetAttributeEligibilityAgeRangeMonths}
   * @memberof ApiPetAttributeEligibility
   */
  ageRangeMonths?: ApiPetAttributeEligibilityAgeRangeMonths;
  /**
   *
   * @type {ApiPetAttributeEligibilityBirthday}
   * @memberof ApiPetAttributeEligibility
   */
  birthday?: ApiPetAttributeEligibilityBirthday;
  /**
   * status of pet considered for micro interaction
   * @type {string}
   * @memberof ApiPetAttributeEligibility
   */
  status?: ApiPetAttributeEligibilityStatusEnum;
  /**
   *
   * @type {string}
   * @memberof ApiPetAttributeEligibility
   */
  breed?: string;
}

/**
 * @export
 */
export const ApiPetAttributeEligibilityStatusEnum = {
  Active: 'active',
  Inactive: 'inactive',
} as const;
export type ApiPetAttributeEligibilityStatusEnum = typeof ApiPetAttributeEligibilityStatusEnum[keyof typeof ApiPetAttributeEligibilityStatusEnum];

export function ApiPetAttributeEligibilityFromJSON(json: any): ApiPetAttributeEligibility {
  return ApiPetAttributeEligibilityFromJSONTyped(json, false);
}

export function ApiPetAttributeEligibilityFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiPetAttributeEligibility {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    profilePhoto: !exists(json, 'profilePhoto') ? undefined : json['profilePhoto'],
    weight: !exists(json, 'weight')
      ? undefined
      : ApiPetAttributeEligibilityWeightFromJSON(json['weight']),
    medicalConditions: !exists(json, 'medicalConditions')
      ? undefined
      : ApiPetAttributeEligibilityMedicalConditionsFromJSON(json['medicalConditions']),
    allergies: !exists(json, 'allergies')
      ? undefined
      : ApiPetAttributeEligibilityAllergiesFromJSON(json['allergies']),
    medications: !exists(json, 'medications')
      ? undefined
      : ApiPetAttributeEligibilityMedicationsFromJSON(json['medications']),
    medicationAllergies: !exists(json, 'medicationAllergies')
      ? undefined
      : ApiPetAttributeEligibilityMedicationAllergiesFromJSON(json['medicationAllergies']),
    ageRangeMonths: !exists(json, 'ageRangeMonths')
      ? undefined
      : ApiPetAttributeEligibilityAgeRangeMonthsFromJSON(json['ageRangeMonths']),
    birthday: !exists(json, 'birthday')
      ? undefined
      : ApiPetAttributeEligibilityBirthdayFromJSON(json['birthday']),
    status: !exists(json, 'status') ? undefined : json['status'],
    breed: !exists(json, 'breed') ? undefined : json['breed'],
  };
}

export function ApiPetAttributeEligibilityToJSON(value?: ApiPetAttributeEligibility | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    profilePhoto: value.profilePhoto,
    weight: ApiPetAttributeEligibilityWeightToJSON(value.weight),
    medicalConditions: ApiPetAttributeEligibilityMedicalConditionsToJSON(value.medicalConditions),
    allergies: ApiPetAttributeEligibilityAllergiesToJSON(value.allergies),
    medications: ApiPetAttributeEligibilityMedicationsToJSON(value.medications),
    medicationAllergies: ApiPetAttributeEligibilityMedicationAllergiesToJSON(
      value.medicationAllergies,
    ),
    ageRangeMonths: ApiPetAttributeEligibilityAgeRangeMonthsToJSON(value.ageRangeMonths),
    birthday: ApiPetAttributeEligibilityBirthdayToJSON(value.birthday),
    status: value.status,
    breed: value.breed,
  };
}
